var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.listArr),function(arr){return _c('div',{key:arr,class:("" + (_vm.mobile ? '' : 'pc_or_tablet mx-auto'))},[_c('Collection',{attrs:{"collection":_vm.list[arr]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }